function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { StreamVideo } from "../stream";
import { MediaFacingMode, MediaTrackType } from "../../view-model";
import { defaultConfigOptions, defaultPhotoOptions, defaultRecordOptions } from "./camera.vm";
import { components as defaultComponents } from "./components";
import clsx from 'clsx';
import { RippleButton } from '@isyc-react/form/modules/base/button';
import { useCameraDimensions } from "./camera-dimensions.hook";
import '@isyc-react/design/main';
import "./camera.style.scss";

// TODO componentizar bien en general en toda la camera etc.

const defaultCameraStreamComponents = {
  CameraConfigButton: defaultComponents.CameraConfigButton,
  CameraPhotoButton: defaultComponents.CameraPhotoButton,
  CameraRecordButton: defaultComponents.CameraRecordButton
};
export const CameraStream = props => {
  const {
    audio,
    state,
    device,
    facingMode,
    components = defaultCameraStreamComponents,
    photo = defaultPhotoOptions,
    record = defaultRecordOptions,
    config = defaultConfigOptions,
    native = true,
    viewportOffset,
    onFacingModeChange,
    onDeviceChange
  } = props;
  const {
    CameraConfigButton = defaultComponents.CameraConfigButton,
    CameraPhotoButton = defaultComponents.CameraPhotoButton,
    CameraRecordButton = defaultComponents.CameraRecordButton
  } = components;
  const {
    allow: allowPhoto,
    options: optionsPhoto,
    onPhoto
  } = photo;
  const {
    allow: allowRecord,
    onRecord,
    options: optionsRecord
  } = record;
  const {
    allow: allowConfig,
    audioInput = defaultConfigOptions.audioInput,
    videoInput = defaultConfigOptions.videoInput
  } = config;
  const {
    audioInputId,
    videoInputId
  } = device;
  const {
    stream,
    data,
    supports
  } = state;
  const [source, setSource] = React.useState(null);
  const [dim, setNative] = useCameraDimensions(native, state.data.video.aspectRatio, viewportOffset);
  const facingModeSupported = React.useMemo(() => supports(MediaTrackType.VIDEO_INPUT, ['facingMode']), [supports]);
  return /*#__PURE__*/React.createElement("div", {
    className: "media-camera-stream"
  }, /*#__PURE__*/React.createElement(StreamVideo, {
    stream: stream,
    mirrored: !facingModeSupported || facingMode === MediaFacingMode.USER,
    className: clsx('media-camera-video-stream', {
      'd-block': source
    }),
    onLoadedMetadata: e => {
      const video = e.target;
      setSource(video);
      setNative({
        height: video.videoHeight,
        width: video.videoWidth
      });
    },
    style: {
      maxHeight: dim.height,
      maxWidth: dim.width
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "media-camera-controls",
    style: {
      maxHeight: dim.height,
      maxWidth: dim.width
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-start h-100 w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 justify-content-start flex-shrink-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-light"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 justify-content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-light"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 justify-content-end flex-shrink-1"
  }, facingModeSupported && /*#__PURE__*/React.createElement(RippleButton, {
    onClick: () => {
      const current = facingMode !== null && facingMode !== void 0 ? facingMode : data.video.facingMode;
      if (current && onFacingModeChange) onFacingModeChange(current === MediaFacingMode.USER ? MediaFacingMode.ENVIRONMENT : MediaFacingMode.USER);
    },
    className: "btn-media-camera config"
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-camera-switch"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-center h-100 w-100"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-end h-100 w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-end w-100 pb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 justify-content-start flex-shrink-1 text-light"
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 justify-content-center text-light"
  }, allowPhoto && /*#__PURE__*/React.createElement(CameraPhotoButton, {
    source: source,
    stream: stream,
    options: _objectSpread(_objectSpread({}, optionsPhoto), {}, {
      mirrored: !facingModeSupported || facingMode === MediaFacingMode.USER
    }),
    onPhoto: onPhoto
  }), allowRecord && /*#__PURE__*/React.createElement(CameraRecordButton, {
    stream: stream,
    onRecord: onRecord,
    options: optionsRecord
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex w-100 justify-content-end flex-shrink-1"
  }, allowConfig && /*#__PURE__*/React.createElement(CameraConfigButton, {
    config: {
      audioInput: audio && audioInput,
      audioOutput: false,
      videoInput
    },
    audioInputDeviceId: audioInputId !== null && audioInputId !== void 0 ? audioInputId : data.audio.deviceId,
    videoInputDeviceId: videoInputId !== null && videoInputId !== void 0 ? videoInputId : data.video.deviceId,
    onChange: change => onDeviceChange && onDeviceChange(change)
  }))))));
};